import React from 'react';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import env from '../../../config/env.js';

const PageArticles = () => {
  const [res, req] = useHttpStatus();

  const handleDownload = async (teacherUrl) => {
    if (!teacherUrl) return;

    const downloadUrl = teacherUrl.startsWith('http')
      ? teacherUrl
      : `${process.env.ROOT || window.location.origin}${teacherUrl.startsWith('/') ? '' : '/'}${teacherUrl}`;

    // If URL is same-origin or relative, fetch it and trigger a blob download (reliable).
    const isSameOrigin = downloadUrl.startsWith('/') || downloadUrl.startsWith(window.location.origin);

    try {
      if (isSameOrigin) {
        const res2 = await fetch(downloadUrl);
        if (!res2.ok) throw new Error(`Download failed: ${res2.status}`);
        const blob = await res2.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        // try to infer filename from URL
        const name = (() => {
          try {
            return new URL(downloadUrl).pathname.split('/').pop() || 'download.pdf';
          } catch (e) { return 'download.pdf'; }
        })();
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(blobUrl);
      } else {
        // Cross-origin: try using an anchor with download first (may be honored),
        // otherwise fallback to opening in a new tab.
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.setAttribute('download', '');
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (err) {
      // last resort: open in new tab
      window.open(downloadUrl, '_blank');
    }
  };

  return (
    <div>
      <Header>Articles</Header>
      <div className="card p-4 mb-4">
        <div className="text-center">
          {
            (() => {
              // Determine global review window from env.certSetting
              let withinGlobalReview = false;
              if (env && env.certSetting) {
                const { reviewOpenDate, reviewCloseDate } = env.certSetting;
                const rOpenMs = reviewOpenDate ? Date.parse(reviewOpenDate) : NaN;
                const rCloseMs = reviewCloseDate ? Date.parse(reviewCloseDate) : NaN;
                if (!Number.isNaN(rOpenMs) && !Number.isNaN(rCloseMs)) {
                  const now = Date.now();
                  withinGlobalReview = now >= rOpenMs && now <= rCloseMs;
                }
              }

              // const disabled = !withinGlobalReview || res.loading;
              const disabled = false;

              return (
                <>
                  <div className="d-flex flex-column flex-md-row justify-content-center gap-2">
                    <button
                      type="button"
                      className={`btn ${disabled ? 'btn-outline-dark disabled' : 'btn-primary'} btn-lg`}
                      onClick={() => handleDownload(env?.certSetting?.teacherPDFURL)}
                      disabled={disabled || !env?.certSetting?.teacherPDFURL}
                      style={disabled ? { opacity: 0.5 } : {}}
                    >
                      {res.loading ? '下載中...' : '初小PDF'}
                    </button>
                    <button
                      type="button"
                      className={`btn ${disabled ? 'btn-outline-dark disabled' : 'btn-primary'} btn-lg`}
                      onClick={() => handleDownload(env?.certSetting?.teacherPDFURL2)}
                      disabled={disabled || !env?.certSetting?.teacherPDFURL2}
                      style={disabled ? { opacity: 0.5 } : {}}
                    >
                      {res.loading ? '下載中...' : '高小PDF'}
                    </button>
                  </div>
                  <p className="text-muted mt-3">
                    {disabled
                      ? '閱讀材料(電子版)下載啟動將於活動結束後開放'
                      : '點擊按鈕下載作業文章的PDF檔案'}
                  </p>
                </>
              );
            })()
          }
          {res.error && (
            <div className="alert alert-danger mt-3" role="alert">
              {res.error.message || '下載失敗，請稍後再試'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageArticles;
